(() => {
	const SESSION_STORAGE_DEVICE_TRACKED_KEY = "sch-has-tracked-user-device";

	const getUserOSFromUserAgent = (userAgent = "") => {
		if (userAgent.includes("Windows")) {
			return { os: "Windows" };
		}

		if (/iPad|iPhone|iPod/gi.test(userAgent)) {
			return { os: "iOS" };
		}

		if (userAgent.includes("Mac")) {
			return { os: "Mac" };
		}

		if (userAgent.includes("Android")) {
			return { os: "Android" };
		}

		if (userAgent.includes("Linux")) {
			return { os: "Linux" };
		}

		return { os: "Unknown" };
	};

	const trackUserDeviceInfo = (retries = 0) => {
		const hasExceededRetries = retries >= 10;
		const analyticsIsNotReady = typeof window.analytics === "undefined";
		const hasTrackedDeviceInfoInSessionBefore =
			sessionStorage.getItem(SESSION_STORAGE_DEVICE_TRACKED_KEY) === "true";

		if (hasExceededRetries || hasTrackedDeviceInfoInSessionBefore) {
			return;
		}

		if (analyticsIsNotReady) {
			setTimeout(() => trackUserDeviceInfo(retries + 1), 1500);
			return;
		}

		const { os } = getUserOSFromUserAgent(navigator.userAgent);

		window.analytics.track("Device Info Received", {
			os,
			deviceScreenWidth: window.innerWidth,
			deviceScreenHeight: window.innerHeight,
		});

		sessionStorage.setItem(SESSION_STORAGE_DEVICE_TRACKED_KEY, "true");
	};

	window.addEventListener("load", () => {
		trackUserDeviceInfo();
	});
})();
